import { useProductOptionFormModelContext } from "../../../../../context";

export const useOptionUseAsSubOption = () => {
	const { viewModel, onSetViewModel } = useProductOptionFormModelContext();
	const { useAsSubOption } = viewModel;

	const isEdited = useAsSubOption.isEdited;
	const hasError = Boolean(useAsSubOption.error);

	const onSetUseAsSubOption = (input: boolean) => {
		onSetViewModel([
			{
				key: "useAsSubOption",
				value: {
					...useAsSubOption,
					value: input,
				},
			},
		]);
	};

	return {
		isEdited,
		hasError,

		useAsSubOption,
		onSetUseAsSubOption,
	};
};
